import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class ProduceSearch {
  /* 订单查询 */
  static getProduceSearchOrderDetaile(option) {
    let url = `/oa/api/order/detail?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default ProduceSearch;